<div class="edit_profile register login">
    <div class="container">
        <div class="row">
            <div class="col-lg-6 m-auto">
                <div class="right_part space-y-20">
                    <h1 class="color_white"> Welcome to Muzella NFT</h1>
                    <p>Have an account ?
                        <a  [routerLink]="['/login']" routerLinkActive="router-link-active">
                            Login </a>
                    </p>
                    <div class="box edit_box w-full space-y-20">
                        <form [formGroup]="registerForm" (ngSubmit)="onRegisterSubmit()">
                            <div class="space-y-10">
                                <span class="nameInput">UserName</span>
                                <div class="confirm">
                                    <!-- style="background: #1c095f !important;" -->
                                    <input type="text" class="form-control" formControlName="username">
                                    <div *ngIf="registerForm.get('username')?.touched" class="text text-danger">
                                        <div *ngIf="registerForm.get('username')?.getError('required')">
                                            UserName is required.
                                        </div>
                                        <div *ngIf="registerForm.get('username')?.getError('pattern')">
                                            UserName must be alphabetic.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="space-y-10"> 
                                <span class="nameInput">FirstName</span>
                                <div class="confirm">
                                    <!-- style="background: #1c095f !important;" -->
                                    <input type="text" class="form-control" formControlName="first_name">
                                    <div *ngIf="registerForm.get('first_name')?.touched" class="text text-danger">
                                        <div *ngIf="registerForm.get('first_name')?.getError('required')">
                                            FirstName is required.
                                        </div>
                                        <!-- <div *ngIf="registerForm.get('first_name')?.getError('pattern')">
                                            FirstName must be alphabetic.
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="space-y-10">
                                <span class="nameInput">LastName</span>
                                <div class="confirm">
                                    <!--  -->
                                    <input type="text" class="form-control" formControlName="last_name">
                                    <div *ngIf="registerForm.get('last_name')?.touched" class="text text-danger">
                                        <div *ngIf="registerForm.get('last_name')?.getError('required')">
                                            LastName is required.
                                        </div>
                                        <!-- <div *ngIf="registerForm.get('last_name')?.getError('pattern')">
                                            LastName must be alphabetic.
                                        </div> -->
                                    </div>
                                </div>
                            </div>
                            <div class="space-y-10">
                                <span class="nameInput">Email </span>
                                <div class="confirm form-group">
                                    <input type="text" class="form-control" formControlName="email"
                                        placeholder="Enter email">
                                    <div *ngIf="registerForm.get('email')?.touched" class="text text-danger">
                                        <div *ngIf="registerForm.get('email')?.getError('required')">
                                            Email is required.
                                        </div>
                                        <div *ngIf="registerForm.get('email')?.getError('email')">
                                            Email is not Valid.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="space-y-10">
                                <span class="nameInput">Password</span>
                                <div class="confirm">
                                    <input [type]="EyeFlag ? 'text' : 'password'" class="form-control"
                                        formControlName="password">
                                    <span class="icr_eye">
                                        <i class="fa fa-eye" [ngClass]="{
                                            'fa-eye-slash': !EyeFlag,
                                            'fa-eye': EyeFlag
                                          }" (click)="onEyeClick()"></i>
                                    </span>
                                    <div *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.invalid"
                                        class="text text-danger">
                                        <div *ngIf="registerForm.get('password')?.getError('required')">
                                            Password is required.
                                        </div>
                                        <div *ngIf="registerForm.get('password')?.getError('minlength')">
                                            Password minimum length is 6.
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="space-y-10">
                                <span class="nameInput">Confirm Password</span>
                                <div class="confirm">
                                    <input [type]="confirmEyeFlag? 'text' : 'password'" class="form-control"
                                        formControlName="confirmPassword">
                                    <!-- <span class="eye_icc">
                                        <i class="fa fa-eye"></i>
                                    </span> -->
                                    <span class="icr_eye">
                                        <i class="fa fa-eye" [ngClass]="{
                                'fa-eye-slash': !confirmEyeFlag,
                                'fa-eye': confirmEyeFlag
                              }" (click)="onConfirmEyeClick()"></i>
                                    </span>
                                    <div *ngIf="registerForm.get('confirmPassword')?.touched && registerForm.get('confirmPassword')?.invalid"
                                        class="text text-danger">
                                        <div *ngIf="registerForm.get('confirmPassword')?.getError('required')">
                                            Confirm Password is required.
                                        </div>
                                        <div *ngIf="registerForm.get('confirmPassword')?.getError('mustMatch')">
                                            Passwords
                                            must
                                            match</div>
                                    </div>

                                </div>
                            </div>
                            <div class="space-y-10 mt-3">
                                <button type="submit" class="btn btn-grad w-full btn-lg"
                                    [disabled]="!registerForm.valid"> Register</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<app-loader *ngIf="spinner"></app-loader>